module.exports = __webpack_public_path__ + "static/img/cjx09.73a8eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx09.png
// module id = 166
// module chunks = 0